import styled from 'styled-components'

import type { TradeType } from '@root/entities/trade-type'

type Props = {
  swapDirection: TradeType.SwapDirection
  title: React.ReactNode
  active?: boolean
  onClick?: () => void
  disabled?: boolean
}

export const InstantTradeSwapOption: React.FC<Props> = ({
  swapDirection,
  title,
  onClick,
  active = false,
  disabled = false,
}) => (
  <Root
    type="button"
    $active={active}
    onClick={onClick}
    $type={swapDirection}
    disabled={disabled}
    data-active={active}
  >
    {title}
  </Root>
)

const Root = styled.button<{
  $active: boolean
  $type: TradeType.SwapDirection
}>`
  border: 1px solid var(--background-4);

  font-size: 11px;
  font-weight: 700;
  border-radius: 10px;
  height: 30px;
  gap: 4px;

  display: grid;
  justify-content: center;
  align-items: center;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  transition: all 0.15s linear;
  cursor: pointer;

  background: ${({ $active }) =>
    $active ? 'var(--background-3)' : 'transparent'};
  color: ${({ $type }) =>
    $type === 'buy' ? 'var(--upAccent-9)' : 'var(--downAccent-9)'};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  &:not(:disabled) {
    &:hover {
      background: ${({ $type }) =>
        $type === 'buy'
          ? 'rgba(var(--upAccent-9-rgb), 0.1)'
          : 'rgba(var(--downAccent-9-rgb), 0.1)'};
      border-color: ${({ $type }) =>
        $type === 'buy' ? 'var(--upAccent-9)' : 'var(--downAccent-9)'};
    }
    &[data-active='true'] {
      border: 1px solid var(--background-6);
      background: var(--background-3);
      color: ${({ $type }) =>
        $type === 'buy'
          ? 'rgba(var(--upAccent-9-rgb), 0.1)'
          : 'rgba(var(--downAccent-9-rgb), 0.1)'};
    }
  }
`
